module.exports = __webpack_public_path__ + "img/yuanxi.7dde671a.png";